import { h } from 'preact'
import StatusCircle from '../../ui-components/StatusCircle'

const StatusCell = () => {
  return ({ status }: { status: string }) => {
    return (
      <div className='overview__status'>
        <StatusCircle variant={status} />
        { status.charAt(0).toUpperCase() + status.slice(1) }
      </div>
    )
  }
}

export default StatusCell
